import HistoryIcon from '@mui/icons-material/History';
import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { reportLabels } from '../../constants/reportLabels';
import ExportDataButton from '../exports/ExportDataButton';
import ExportReportButton from './ExportReportButton';
import ReportHistoryDialog from './ReportHistoryDialog';

interface ReportActionsProps {
  projectId: string;
  hasUnsavedChanges: boolean;
  /** Read-only viewers can export data and browse reports but cannot generate a new one. */
  readOnly?: boolean;
}

const ReportActions = ({ projectId, hasUnsavedChanges, readOnly = false }: ReportActionsProps) => {
  const [historyOpen, setHistoryOpen] = useState(false);

  return (
    <>
      {!readOnly && <ExportReportButton projectId={projectId} hasUnsavedChanges={hasUnsavedChanges} />}
      <ExportDataButton projectId={projectId} hasUnsavedChanges={hasUnsavedChanges} />
      <Tooltip title={reportLabels.history_button}>
        <IconButton aria-label={reportLabels.history_button} aria-haspopup="dialog" onClick={() => setHistoryOpen(true)}>
          <HistoryIcon />
        </IconButton>
      </Tooltip>
      <ReportHistoryDialog projectId={projectId} open={historyOpen} onClose={() => setHistoryOpen(false)} />
    </>
  );
};

export default ReportActions;
